export default __webpack_public_path__ + "static/media/amor.be1c8cfc.png";